import { render } from "./AdminAppsAdd.vue?vue&type=template&id=6b8bc81b"
import script from "./AdminAppsAdd.vue?vue&type=script&lang=js"
export * from "./AdminAppsAdd.vue?vue&type=script&lang=js"

import "./AdminAppsAdd.vue?vue&type=style&index=0&id=6b8bc81b&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__